import * as React from 'react';
import AsyncSelect from 'react-select/async';
import { useToken } from '@chakra-ui/react';

const CustomAsyncSelect = ({
  height = 48,
  isClearable = false,
  isDisabled = false,
  isMulti = false,
  isSearchable = false,
  menuPlacement = 'bottom',
  onChange,
  placeholder = '',
  loadOptions = undefined,
  value = undefined,
  width = null,
  maxWidth = 340,
}) => {
  const [
    muted100,
    primary50,
    primary100,
    primary800,
    secondary100,
    secondary500,
  ] = useToken('colors', [
    'muted.100',
    'primary.50',
    'primary.100',
    'primary.800',
    'secondary.100',
    'secondary.500',
  ]);

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      isClearable={isClearable}
      isDisabled={isDisabled}
      isMulti={isMulti}
      isSearchable={isSearchable}
      loadOptions={loadOptions}
      menuPlacement={menuPlacement}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
      onChange={onChange}
      placeholder={placeholder}
      styles={{
        menuPortal: (base) => ({
          ...base,
          fontSize: '14px',
          maxWidth,
          zIndex: 9999,
        }),
        container: (base) => ({
          ...base,
          width,
        }),
        control: (base, state) => ({
          ...base,
          fontSize: '14px',
          height,
          maxWidth,
          backgroundColor: state.isDisabled
            ? muted100
            : base.backgroundColor,
        }),
        valueContainer: (base) => ({
          ...base,
          maxHeight: '100%',
          overflow: 'scroll',
        }),
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          neutral20: secondary500,
          neutral30: secondary100,
          primary: primary800,
          primary25: primary50,
          primary50: primary100,
        },
      })}
      value={value}
    />
  );
};

export { CustomAsyncSelect as AsyncSelect };
